{
  "loading": "Cargando…",
  "placeholder": "Seleccione una opción…"
}
